<template>
  <BaseTableView :head="tableHead">
    <UsersListItem
      v-for="user in userGrid"
      :key="user.id"
      :user="user"
      :onDownloadPageData="onDownloadPageData"
      :subscriber="subscriber"
    />
  </BaseTableView>
</template>

<script>
import UsersListItem from 'components/setting/users/UsersListItem'

export default {
  name: 'UsersTable',
  props: { userGrid: Array, onDownloadPageData: Function, subscriber: Boolean },
  components: {
    UsersListItem,
  },
  data: () => ({
    dialog: false,
    search: '',
    tableMin: false,
  }),
  computed: {
    tableHead() {
      return [
        {
          text: this.localStorage.translations.pages['setting-users'].tables['familiya-imya'],
          sort: {
            name: 'last_name',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'last_name'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'asc',
          },
        },
        {
          text: this.localStorage.translations.pages['setting-users'].tables['elektronnaya-pochta'],
          sort: {
            name: 'email',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'email'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'asc',
          },
        },
        {
          text: this.localStorage.translations.pages['setting-users'].tables['telefon'],
          sort: {
            name: 'phone',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'phone'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'asc',
          },
        },
        {
          text: this.localStorage.translations.pages['setting-users'].tables['status'],
        },
        {
          text: this.localStorage.translations.pages['setting-users'].tables['visit'],
          sort: {
            name: 'last_request',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'last_request'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
          },
        },
        {
          text: this.localStorage.translations.pages['setting-users'].tables['rol'],
        },
        {
          text: !this.subscriber
            ? this.localStorage.translations.pages['setting-users'].tables['sotrudnik']
            : this.localStorage.translations.pages.planning_orders.table.proekt,
        },
        {
          text: this.localStorage.translations.pages['setting-users'].tables['offer'],
        },
        {
          text: '',
          active: true,
        },
      ]
    },
  },
}
</script>
